import Swal from 'sweetalert2';
export function showSuccessMessage({
    title = "¡ Éxito !",
    message = "",
}:any, action: () => void) {
    Swal.fire(
        title,
        message,
        'success'
    ).then((_) => {
        action()
    })
}